import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Button from "../Button";
import DatePickerInput from "../Datepicker";
import Search from "../Search";
import TicketFilter from "./TicketFilter";
import DateFilter from './DateFilter';
import TypeFilter from "./TypeFilter";
const downloadIcon = require("../../assets/images/download-icon.png");

interface Props {
    reportDate: Date;
    today: Date;
    onFilterSelect: any;
    onFilterSelectDate: any;
    onFilterType: any;
    selectedFilter: number;
    dateTypefilter: number;
    dateFilter: number;
    filterEntities: any;
    filterTypeEntities: any;
    filterDateEntities: any;
    onClearFilter: any;
    onClearFilterDate: any;
    onClearFilterType: any;
    productList: any;
    onAgentSelect: any;
    onSetReportDate: any;
    searchQuery: string;
    onSearch: any;
    onSaveFilter: any;
    onDownload: any,
    agent: string
}

const TicketSubHeader = ({
    reportDate,
    today,
    onFilterSelect,
    onFilterSelectDate,
    onFilterType,
    selectedFilter,
    dateTypefilter,
    dateFilter,
    filterEntities,
    filterTypeEntities,
    filterDateEntities,
    onClearFilter,
    onClearFilterDate,
    onClearFilterType,
    productList,
    onAgentSelect,
    onSetReportDate,
    searchQuery,
    onSearch,
    onSaveFilter,
    onDownload,
    agent
}: Props) => {
    return (
        <StyledReportTabHeader>
            <FieldContainer>
                <DateFilter
                    onFilterSelect={onFilterSelectDate}
                    reportDate={reportDate}
                    width="15rem"
                    onChange={() => console.log("")}
                    value={
                        filterDateEntities.filter(
                            (fl: any, index: any) => index === dateFilter
                        )[0].label
                    }
                    filterEntities={filterDateEntities}
                    selectedFilter={dateFilter}
                    onClearFilter={onClearFilterDate}
                    onAgentSelect={onAgentSelect}
                    onSaveFilter={onSaveFilter}
                    onSetReportDate={onSetReportDate}

                />
                <TypeFilter
                    onFilterSelect={onFilterType}
                    width="15rem"
                    onChange={() => console.log("")}
                    value={
                        filterTypeEntities.filter(
                            (fl: any, index: any) => index === dateTypefilter
                        )[0].label
                    }
                    filterEntities={filterTypeEntities}
                    selectedFilter={dateTypefilter}
                    onClearFilter={onClearFilterType}
                    productList={productList}
                    onAgentSelect={onAgentSelect}
                    onSaveFilter={onSaveFilter}
                    agent={agent}
                />

                <TicketFilter
                    onFilterSelect={onFilterSelect}
                    width="15rem"
                    onChange={() => console.log("")}
                    value={
                        filterEntities.filter(
                            (fl: any, index: any) => index === selectedFilter
                        )[0].label
                    }
                    filterEntities={filterEntities}
                    selectedFilter={selectedFilter}
                    onClearFilter={onClearFilter}
                    productList={productList}
                    onAgentSelect={onAgentSelect}
                    onSaveFilter={onSaveFilter}
                    agent={agent}
                />
            </FieldContainer>
        </StyledReportTabHeader>
    );
};

const FieldContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  justify-content: space-between;
  @media only screen and (max-width: 1024px) {
    flex-direction:column;
  }
`;
const ActionContainer = styled.div`
  display: flex;
  gap: 3rem;
  align-items: center;
  padding-top: 0.5rem;
  @media only screen and (max-width: 1024px) {
    flex-direction:column;
  padding-top: 2rem;

  }
`;
const StyledReportTabHeader = styled.div`
  margin: 1rem 0;
  padding:1rem;
  display: flex;
  align-content: center;
  justify-content: space-between;
  @media only screen and (max-width: 1024px) {
    flex-direction:column;
    margin: 0rem 0;
  }
`;

export default TicketSubHeader;
